import React, { useEffect, useState } from "react";
import { Button, Form, Spin } from "antd";
import { FieldTypes, generateFormFields } from "utils/formUtils";
import message from "components/CustomMessage";
import GlobalSettingAPI from "restAPI/GlobalSettingAPI";
import AppLoader from "components/AppLoader";

const SecureCodeWarriorForm = ({ name: trainingName, ...props }) => {
  const [isEnabled, setIsEnabled] = useState(true);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { promise, cancel } = GlobalSettingAPI.getSecureCodeWarriorConfig();
    promise
      .then((data) => {
        if (data) {
          setIsEnabled(data.isEnabled);
        }
      })
      .finally(() => setLoading(false));

    return () => {
      cancel();
    };
  }, [form]);

  useEffect(() => {
    form.setFieldsValue({
      isEnabled: isEnabled,
    });
  }, [isEnabled, form]);

  const handleSave = async () => {
    await form.validateFields();
    const config = {
      isEnabled: form.getFieldValue("isEnabled"),
    };
    const { promise } =
      GlobalSettingAPI.updateSecureCodeWarriorConfig(config);
    promise.then(() => {
      message.success(
        `Secure Code Warrior ${
          config.isEnabled ? "enabled" : "disabled"
        } successfully`
      );
    });
  };


  const fields = [
    {
      name: "isEnabled",
      label: "Enable/Disable Secure Code Warrior",
      type: FieldTypes.SWITCH,
      inline: true,
    },
  ];

  return (
    <Spin spinning={loading} indicator={<AppLoader />}>
      <Form
        form={form}
        layout="vertical"
        style={{ padding: "20px", maxWidth: "400px" }}
      >
        {generateFormFields(fields)}

        <Button type="primary" onClick={handleSave}>
          Save
        </Button>
      </Form>
    </Spin>
  );
};

export default SecureCodeWarriorForm;
